export default __webpack_public_path__ + "static/media/CANCIONES_DISCO_04.b2ac4e60.png";